import { Divider } from '@components/core-ui/Divider';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { usePageContext } from '../../providers/PageProvider';
import { Organizations } from './components/Organizations';
import { Teams } from './components/Teams';
import { UserDetails } from './components/UserDetails';
import { Workspaces } from './components/Workspaces';

import { Wrapper } from './styles/Wrapper';

export const Content = () => {
  const { user, isLoading, fetchData } = usePageContext();

  if (!user || isLoading) {
    return (
      <Wrapper>
        <AbsoluteSpinner overlay={true} />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <UserDetails user={user} reload={fetchData} />
      <Divider />
      <Organizations user={user} />
      <Divider />
      <Workspaces user={user} />
      <Divider />
      <Teams user={user} />
    </Wrapper>
  );
};
